import { useState as w, useRef as v, useEffect as a, useCallback as E, useLayoutEffect as p } from "react";
var L = typeof window < "u" ? p : a;
function O(t, e, r, s) {
  const u = v(e);
  L(() => {
    u.current = e;
  }, [e]), a(() => {
    const o = window;
    if (!(o && o.addEventListener))
      return;
    const n = (i) => {
      u.current(i);
    };
    return o.addEventListener(t, n, s), () => {
      o.removeEventListener(t, n, s);
    };
  }, [t, r, s]);
}
function x() {
  const t = v(!1);
  return a(() => (t.current = !0, () => {
    t.current = !1;
  }), []), E(() => t.current, []);
}
function I(t, e, r = "mousedown", s = {}) {
  O(
    r,
    (u) => {
      const o = u.target;
      if (!o || !o.isConnected)
        return;
      (Array.isArray(t) ? t.filter((i) => !!i.current).every((i) => i.current && !i.current.contains(o)) : t.current && !t.current.contains(o)) && e(u);
    },
    void 0,
    s
  );
}
var y = {
  width: void 0,
  height: void 0
};
function A(t) {
  const { ref: e, box: r = "content-box" } = t, [{ width: s, height: u }, o] = w(y), n = x(), i = v({ ...y }), d = v(void 0);
  return d.current = t.onResize, a(() => {
    if (!e.current || typeof window > "u" || !("ResizeObserver" in window))
      return;
    const c = new ResizeObserver(([f]) => {
      const g = r === "border-box" ? "borderBoxSize" : r === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", b = S(f, g, "inlineSize"), m = S(f, g, "blockSize");
      if (i.current.width !== b || i.current.height !== m) {
        const h = { width: b, height: m };
        i.current.width = b, i.current.height = m, d.current ? d.current(h) : n() && o(h);
      }
    });
    return c.observe(e.current, { box: r }), () => {
      c.disconnect();
    };
  }, [r, e, n]), { width: s, height: u };
}
function S(t, e, r) {
  return t[e] ? Array.isArray(t[e]) ? t[e][0][r] : (
    // @ts-ignore Support Firefox's non-standard behavior
    t[e][r]
  ) : e === "contentBoxSize" ? t.contentRect[r === "inlineSize" ? "width" : "height"] : void 0;
}
var l = /* @__PURE__ */ new Map();
function j(t) {
  const e = document.querySelector(
    `script[src="${t}"]`
  ), r = e?.getAttribute("data-status");
  return {
    node: e,
    status: r
  };
}
function C(t, e) {
  const [r, s] = w(() => e?.shouldPreventLoad ? "idle" : typeof window > "u" ? "loading" : l.get(t) ?? "loading");
  return a(() => {
    if (e?.shouldPreventLoad)
      return;
    const u = l.get(t);
    if (u === "ready" || u === "error") {
      s(u);
      return;
    }
    const o = j(t);
    let n = o.node;
    if (n)
      s(o.status ?? u ?? "loading");
    else {
      n = document.createElement("script"), n.src = t, n.async = !0, e?.id && (n.id = e.id), n.setAttribute("data-status", "loading"), document.body.appendChild(n);
      const d = (c) => {
        const f = c.type === "load" ? "ready" : "error";
        n?.setAttribute("data-status", f);
      };
      n.addEventListener("load", d), n.addEventListener("error", d);
    }
    const i = (d) => {
      const c = d.type === "load" ? "ready" : "error";
      s(c), l.set(t, c);
    };
    return n.addEventListener("load", i), n.addEventListener("error", i), () => {
      n && (n.removeEventListener("load", i), n.removeEventListener("error", i)), n && e?.removeOnUnmount && (n.remove(), l.delete(t));
    };
  }, [t, e?.shouldPreventLoad, e?.removeOnUnmount, e?.id]), r;
}
export {
  I as a,
  C as b,
  A as u
};
//# sourceMappingURL=index.ByijsZJJ.js.map
